import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { IconModule, SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../../shared/material.module'
import { SharedModule } from '../../../../../shared/shared.module'
import { NewDispenserCreditRequestComponent } from './new-dispenser-credit-request.component'

@NgModule({
  declarations: [NewDispenserCreditRequestComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule, MaterialModule, FormsModule, IconModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        NewDispenserCreditRequestComponent: {
          component: NewDispenserCreditRequestComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class NewDispenserCreditRequestModule {}
